import React from 'react';
import { FaGraduationCap, FaWhatsapp, FaArrowRight } from 'react-icons/fa';
import './Home.css';
import CompanyPresentation from '../CompanyPresentation/CompanyPresentation';
import TestimonialsSection from '../TestimonialsSection/TestimonialsSection';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import FAQSection from '../FAQ/FAQSection';
import WhyChooseUs from '../WhyChooseUs/WhyChooseUs';
import ServicesSection from '../ServicesSection/ServicesSection';
import heroImage from '../../assets/images/63821.jpg';

const Home = () => {
  const openWhatsApp = () => {
    window.open('https://wa.me/33763705088', '_blank');
  };

  return (
    <div className="btg-home">
      {/* Hero Section Premium */}
      <section className="btg-hero-section">
        <div className="btg-hero-background">
          <img src={heroImage} alt="Étudiants internationaux réalisant leur rêve d'études en France" className="btg-hero-image" />
          <div className="btg-hero-overlay"></div>
          <div className="btg-hero-gradient"></div>
        </div>
        
        {/* Éléments décoratifs */}
        <div className="btg-hero-shapes">
          <div className="btg-shape btg-shape-1"></div>
          <div className="btg-shape btg-shape-2"></div>
          <div className="btg-shape btg-shape-3"></div>
          <div className="btg-shape btg-shape-4"></div>
        </div>
        
        <div className="btg-container">
          <div className="btg-hero-content">
            {/* Badge d'expertise */}
            <div className="btg-hero-badge">
              {/* <div className="btg-badge-content">
                <FaGraduationCap className="btg-badge-icon" />
                <span className="btg-badge-text">Expert Accrédité - Études en France</span>
                <div className="btg-badge-glow"></div>
              </div> */}
            </div>
            
            {/* Titre principal */}
            <h1 className="btg-hero-title">
              <span className="btg-title-line">BTG CONSEIL, votre partenaire</span>
              <span className="btg-title-line btg-title-accent"> pour étudier en France.</span>
            </h1>

            {/* CTA Principal */}
            <div className="btg-hero-cta">
              <button className="btg-cta-button btg-cta-primary" onClick={openWhatsApp}>
                <FaWhatsapp className="btg-cta-icon" />
                <span>Démarrer mon projet gratuitement</span>
                <FaArrowRight className="btg-cta-arrow" />
                <div className="btg-button-glow"></div>
              </button>
              
              <div className="btg-cta-note">
                <span>Consultation gratuite sans engagement</span>
              </div>
            </div>
          </div>
        </div>

        {/* Indicateur de défilement */}
        <div className="btg-scroll-indicator">
          <div className="btg-scroll-text">Découvrir nos services</div>
          <div className="btg-scroll-arrow"></div>
        </div>
      </section>

      {/* Sections suivantes */}
      <CompanyPresentation />
      <ServicesSection />
      <WhyChooseUs />
      <TestimonialsSection />
      <FAQSection />
      <Header />
      <Footer />
    </div>
  );
};

export default Home;